import { render } from "./CustomerDetailPaymentsTab.vue?vue&type=template&id=67ad0f1a"
import script from "./CustomerDetailPaymentsTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailPaymentsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__